const pl = {
  common: {
    loading: "Załadunek...",
    close: "Zamknąć",
    submit: "Składać",
    review: "Recenzja",
    help: "Pomoc",
    tour: "Wycieczka",
    instructions: "Instrukcje",
    language: "Język",
    ok: "OK",
    appLoaderText:
      "Ładowanie... Proszę czekać, podczas gdy przygotowujemy środowisko oceny."
  },
  assessment: {
    fetchError: "Błąd podczas pobierania {{featureName}}",
    somethingWentWrong: "Coś poszło nie tak.",
    goBackToDashboard: "Wróć do pulpitu nawigacyjnego",
    confirmSubmissionTitle: "Potwierdź przesłanie",
    scheduleIdNotFound: "Nie znaleziono identyfikatora harmonogramu",
    ongoingIdNotFound: "Nie znaleziono bieżącego identyfikatora",
    errorFetchingOngoingData: "Błąd podczas pobierania bieżących danych",
    connectionRestoredLabel: "Połączenie przywrócone.",
    connectionRestoredDescription:
      "Możesz kontynuować uruchamianie przypadków testowych.",
    connectionLostLabel: "Straciliśmy połączenie z serwerem testowym.",
    connectionLostDescription:
      "W tej chwili nie będziesz mógł uruchamiać ani sprawdzać przypadków testowych.",
    featureNames: {
      assessment: "Ocena",
      knowledgeCheck: "Kontrola wiedzy"
    },
    cardStatus: {
      na: "Nie dotyczy",
      toBeLaunched: "Do uruchomienia",
      expired: "Wygasło",
      expiringSoon: "Wkrótce wygaśnie",
      ongoing: "W trakcie"
    },
    cardState: {
      draft: "Szkic",
      published: "Opublikowano",
      cancelled: "Anulowano",
      inreview: "W recenzji",
      readytopublish: "Gotowe do publikacji",
      sentback: "Odesłano"
    },
    dashboard: {
      videoProctoring: "Ochrona wideo",
      submitFeature: "Prześlij {{featureName}}",
      noSectionsFound: "Nie znaleziono żadnych sekcji",
      expandAllSections: "Rozwiń wszystkie sekcje",
      closeAllSections: "Zamknij wszystkie sekcje",
      continueShapingAssessments: "Kontynuuj tworzenie swoich ocen",
      viewAll: "Zobacz wszystko",
      legend: {
        notStarted: "Nie rozpoczęte",
        inProgress: "W toku",
        completed: "Zakończony"
      }
    },
    confirmModal: {
      description:
        "Po przesłaniu nie będziesz mógł wprowadzać żadnych zmian w swojej {{featureName}}. Przed potwierdzeniem przejrzyj swoje odpowiedzi. Czy chcesz kontynuować przesyłanie?",
      lowWordCountWarning:
        "Twoja odpowiedź na pytanie {{questionTitle}} składa się z mniej niż 40 słów. Jeśli prześlesz ocenę teraz, ta odpowiedź nie zostanie zapisana.",
      videoNotSubmittedWarning:
        "Twój nagrany film wideo dotyczący pytania {{questionTitle}} nie został przesłany. Przesłanie oceny teraz spowoduje odrzucenie tej odpowiedzi.",
      unansweredQuestions: "Masz {{count}} pytań bez odpowiedzi",
      andFlaggedQuestions: "i {{count}} oznaczone pytania",
      failedToFinish: "Nie udało się ukończyć {{featureName}}"
    },
    feedback: {
      submittedTitle: "Twoja {{featureName}} została pomyślnie przesłana!",
      submittedDescription:
        "Twoje odpowiedzi zostały przesłane. Doceniamy czas i wysiłek włożony w ukończenie tej {{featureName}}!",
      resultInProgress:
        "Trwa obliczanie wyniku. Może to potrwać do minuty. Proszę czekać...",
      resultReady:
        "Wynik jest gotowy! Kliknij przycisk Pokaż wynik, aby go wyświetlić.",
      resultDelayed:
        "Obliczanie wyników zajmuje więcej czasu niż zwykle. Aby uzyskać wynik, skontaktuj się z administratorem.",
      showResult: "Pokaż wynik",
      redirectingToResult:
        "Przekierowanie do strony wyników za {{seconds}} sekund, jeśli nie klikniesz przycisku Pokaż wynik",
      shareFeedbackTitle: "Podziel się swoją opinią",
      shareFeedbackDescription:
        "Twoje spostrzeżenia torują drogę do rozwoju. Wspólnie awansujmy!",
      errorSubmittingFeedback: "Błąd podczas przesyłania opinii",
      feedbackSubmittedTitle: "Wszystko gotowe. Opinia została przesłana!",
      feedbackSubmittedDescription:
        "Twoja opinia została przesłana. Dziękujemy, że pomogłeś nam ulepszyć doświadczenie {{featureName}}!",
      feedbackAlreadySubmittedTitle:
        "Wszystko gotowe, opinia została już przesłana!",
      feedbackAlreadySubmittedDescription:
        "Wygląda na to, że opinia została już przesłana. Dziękujemy, że pomogłeś nam ulepszyć doświadczenie {{featureName}}!"
    },
    page: {
      errorFetchingPreAssessmentData:
        "Błąd podczas pobierania danych przed oceną",
      connectionRestoredLabel: "Połączenie przywrócone.",
      connectionRestoredDescription: "Synchronizowanie najnowszych zmian...",
      offlineLabel: "Wygląda na to, że jesteś offline.",
      offlineDescription:
        "Zmiany nie zostaną zsynchronizowane, dopóki nie połączysz się ponownie"
    },
    question: {
      questions: "Pytania",
      closeQuestionsPanel: "Zamknij panel pytań",
      collapse: "Zawalić się",
      sectionSummary: "Podsumowanie sekcji",
      sections: "Sekcje",
      toggleQuestionsPanel: "Przełącz panel pytań",
      switchModal: {
        switchQuestionButton: "Zmień pytanie",
        leaveHeading: "Czy na pewno chcesz wyjść?",
        discardMessage:
          "Masz niezapisane zmiany. Jeśli zmienisz pytanie, Twoja odpowiedź zostanie trwale usunięta.",
        saveChangesButton: "Zapisz zmiany",
        saveHeading: "Czy chcesz zapisać zmiany?",
        saveBeforeSwitchMessage:
          "Masz niezapisane zmiany. Czy chcesz je zapisać przed zmianą pytania?"
      }
    },
    faq: {
      q1: {
        question: "Co powinienem zrobić przed rozpoczęciem {{featureName}}?",
        firstSentence: "Upewnij się, że wykonałeś następujące czynności:",
        list: {
          item1: "Stabilne łącze internetowe",
          item2:
            "Działająca kamera internetowa i mikrofon (jeśli włączona jest funkcja nadzoru wideo)",
          item3: "Ciche otoczenie wolne od zakłóceń",
          item4:
            "Jeśli włączona jest funkcja nadzoru wideo, zostaniesz poproszony o dokończenie sprawdzania systemu.",
          item5: "Przeczytaj i zaakceptuj Regulamin"
        }
      },
      q2: {
        question:
          "Czy mogę poruszać się pomiędzy pytaniami lub sekcjami podczas {{featureName}}?",
        firstSentence: "Nawigacja zależy od ustawień.",
        list: {
          item1:
            "Jeżeli nawigacja po sekcjach jest włączona, możesz poruszać się pomiędzy sekcjami.",
          item2:
            "Jeśli opcja jest wyłączona, przed przejściem do następnej konieczne będzie ukończenie jednej sekcji."
        },
        lastSentence:
          "Instrukcje będą dostępne przez cały czas podczas {{featureName}}."
      },
      q3: {
        question: "Czy będę monitorowany podczas testu?",
        list: {
          item1:
            "Jeśli ta {{featureName}} ma włączoną funkcję nadzoru wideo, zostanie użyta Twoja kamera i mikrofon.",
          item2:
            "Każda nietypowa aktywność może zostać oznaczona do sprawdzenia."
        }
      },
      q4: {
        question:
          "Co się stanie, jeśli stracę połączenie internetowe lub przypadkowo zamknę przeglądarkę?",
        firstSentence: "Twoje postępy są automatycznie zapisywane.",
        lastSentence:
          "Jeśli nastąpi rozłączenie, możesz ponownie dołączyć do {{featureName}}, korzystając z tego samego łącza."
      },
      q5: {
        question:
          "Czy po teście będę mógł zobaczyć moje wyniki lub informację zwrotną?",
        firstSentence:
          "Wyniki i opinie są konfigurowane przez organizatora {{featureName}}.",
        list: {
          item1:
            "Jeśli ta opcja jest włączona, po przesłaniu zobaczysz podsumowanie swoich wyników i opinii.",
          item2:
            "Jeśli nie, Twoje wyniki zostaną udostępnione za pośrednictwem zarejestrowanego adresu e-mail."
        }
      }
    },
    labels: {
      totalDuration: "Całkowity czas trwania",
      numberOfQuestions: "Liczba pytań",
      numberOfSections: "Liczba sekcji",
      guidelines: "Wytyczne",
      platformHelp: "Pomoc platformy",
      faq: "Często zadawane pytania",
      frequentlyAskedQuestions: "Często zadawane pytania",
      showFeatureInstructions: "Pokaż instrukcje {{featureName}}",
      minutes: "protokół",
      welcome: "Powitanie",
      welcomeBack: "Witamy z powrotem",
      userFallback: "Użytkownik",
      defaultGuidelines:
        "Przed uruchomieniem {{featureName}} upewnij się, że znajdujesz się w cichym, wolnym od zakłóceń miejscu ze stabilnym połączeniem internetowym. Przez cały test trzymaj aparat włączony i mądrze zarządzaj czasem, ponieważ jest ograniczony czas. Jeśli napotkasz jakiekolwiek problemy techniczne, natychmiast skontaktuj się z pomocą techniczną. Po zakończeniu przejrzyj swoje odpowiedzi przed przesłaniem. Powodzenia!"
    },
    zoom: {
      textSize: "Rozmiar tekstu:",
      decreaseTextSize: "Zmniejsz rozmiar tekstu (A-)",
      resetTextSize: "Zresetuj rozmiar tekstu (A)",
      increaseTextSize: "Zwiększ rozmiar tekstu (A+)",
      decreaseInterfaceSize: "Zmniejsz rozmiar interfejsu",
      resetInterfaceSize: "Zresetuj rozmiar interfejsu",
      increaseInterfaceSize: "Zwiększ rozmiar interfejsu"
    },
    wrapper: {
      warningTitle: "Ostrzeżenie!",
      stayOnPageMessage:
        "Pozostań na tej stronie, aż ukończysz {{featureName}}.",
      iUnderstand: "Rozumiem",
      submitTheFeature: "Prześlij {{featureName}}",
      videoProctoringInterrupted: "Przerwano nadzór wideo",
      continuationBlocked:
        "Kontynuacja oceny jest zablokowana do czasu przywrócenia bezpiecznego nadzoru wideo.",
      retryProctoring: "Ponów próbę nadzorowania"
    },
    progress: {
      proceed: "Przystępować",
      resumeFeature: "Wznów {{featureName}}",
      timeRemainingMessage:
        "pozostające w {{featureName}}. Kliknij poniżej, aby kontynuować od miejsca, w którym przerwałeś.",
      continueOnThisDevice: "Kontynuować na tym urządzeniu?",
      switchToThisTab: "Przełączyć się na tę kartę?",
      continueYourAssessmentHere: "Kontynuować ocenę tutaj?",
      switchHere: "Przełącz tutaj",
      attemptsUnlimited:
        "W przypadku tej oceny masz nieograniczoną liczbę prób.",
      attemptsSingle: "Masz <strong>1</strong> próbę wykonania tej oceny.",
      attemptsMultiple:
        "Masz <strong>{{remainingAttempts}}</strong> z <strong>{{maxAttempts}}</strong> prób dostępnych do tej oceny.",
      coolOffAfterAttempt:
        "Po każdej próbie musisz poczekać <strong>{{coolOffTime}}</strong> przed rozpoczęciem kolejnej próby."
    },
    loginWindow: {
      expiredTitle: "Upłynął czas logowania",
      expiredMessage:
        "Okno logowania dla tej {{featureName}} jest teraz zamknięte. Przegapiłeś dozwolony czas dostępu do testu."
    },
    coding: {
      saving: "Oszczędność",
      offlineTitle: "Wygląda na to, że jesteś offline",
      offlineDescription:
        "Zmiany nie zostaną zsynchronizowane, dopóki nie połączysz się ponownie",
      connectionRestored: "Połączenie przywrócone",
      syncingLatest: "Synchronizowanie najnowszych zmian...",
      autoSaveEnabled: "Automatyczne zapisywanie włączone",
      runOnlyChecksDescription:
        "tylko sprawdza Twój kod względem przypadków testowych.",
      submitEvaluationDescription:
        "swój kod, aby został oceniony i aby otrzymać punkty.",
      reset: "Resetuj",
      run: "Uruchom",
      runTests: "Testy uruchomieniowe",
      submit: "Składać",
      submitting: "Przedkładający",
      resetCode: "Zresetuj kod",
      resetCodeMessage:
        "Czy na pewno chcesz zresetować? Spowoduje to usunięcie całego bieżącego kodu i przywrócenie kodu startowego",
      testCases: "Przypadki testowe",
      testCase: "Przypadek testowy {{index}}",
      testCasePassed: "Sprawa testowa zaliczona",
      testCaseFailed: "Przypadek testowy nie powiódł się",
      runtimeError: "Błąd wykonania",
      timeLimitExceeded: "Przekroczono limit czasu",
      timeLimitExceededTitle: "Przekroczono limit czasu",
      timeLimitExceededDescription:
        "Twój kod nie został wykonany w określonym czasie. Zoptymalizuj swój kod.",
      input: "Wejście",
      expectedOutput: "Oczekiwany wynik",
      yourOutput: "Twoje wyjście",
      hiddenTestCase: "Ukryty przypadek testowy",
      hiddenTestCaseDescription:
        "Ukryte przypadki testowe służą do oceny, czy kod może obsłużyć różne scenariusze, w tym przypadki narożne",
      explanation: "Wyjaśnienie",
      hints: "Poradnik"
    },
    subjective: {
      minWordsRequired:
        "Aby przesłać odpowiedź, wymagane jest minimum 40 słów.",
      enterYourAnswer: "Wpisz swoją odpowiedź",
      submitResponse: "Prześlij odpowiedź",
      submittingResponse: "Przesyłanie odpowiedzi...",
      resetAnswer: "Zresetuj odpowiedź",
      resetAnswerMessage:
        "Czy na pewno chcesz zresetować? Twoja bieżąca odpowiedź zostanie trwale usunięta.",
      retake: "Odzyskać",
      showHint: "Pokaż wskazówkę",
      recording: "NAGRANIE"
    },
    systemCheck: {
      calibrate: "Kalibrować",
      calibrating: "Kalibracja...",
      accessDenied: "Odmowa dostępu",
      cameraPermissionDenied:
        "Odmowa dostępu do kamery. Aby kontynuować, włącz dostęp do kamery w ustawieniach przeglądarki.",
      errorFetchingDevices: "Błąd podczas pobierania urządzeń",
      failedToStartAssessment: "Nie udało się rozpocząć oceny",
      unableToStartSecureProctoring:
        "Nie można teraz rozpocząć bezpiecznego nadzoru. Spróbuj ponownie.",
      unnamedCamera: "Nienazwana kamera",
      facingCalibrationIssues: "Masz problemy z kalibracją wideo?",
      lookAtCenter: "Proszę spojrzeć na środek ekranu i pozostać nieruchomym.",
      unableToCalibrateTitle:
        "Nie możesz skalibrować kamery pod kątem nadzoru wideo?",
      statusMessages: {
        readyForCalibration:
          "Upewnij się, że Twoja twarz jest wyraźnie widoczna i wyśrodkowana na ekranie. Gdy wszystko będzie gotowe, kliknij „Kalibruj”, aby rozpocząć.",
        calibratingInProgress: "Kalibracja w toku. Patrz dalej na ekran.",
        calibratingTimedOut:
          "Upłynął limit czasu kalibracji aparatu. Aby kontynuować, odśwież przeglądarkę.",
        preparingCameraPreview:
          "Przygotowanie strumienia kamery i śledzenia twarzy do kalibracji.",
        retryRequired:
          "Aby kontynuować, konfiguracja Proctoring wymaga podjęcia działań.",
        proctoringUnavailable:
          "Funkcja nadzoru jest obecnie niedostępna i nie można bezpiecznie rozpocząć oceny.",
        calibrationCompleted:
          "Kalibracja udana! Wszystko gotowe, aby rozpocząć ocenę.",
        timeoutHelp:
          "Jeśli nadal widzisz ten komunikat, sprawdź, czy są inne karty/aplikacje korzystające z aparatu lub zewnętrznej migawki."
      },
      failureReasons: {
        cameraPermissionDenied:
          "Zezwolenie na kamerę jest zablokowane. Zezwól na dostęp i spróbuj ponownie.",
        cameraUnavailable:
          "Kamera jest niedostępna. Sprawdź wybór urządzenia i spróbuj ponownie.",
        facemeshInitFailed:
          "Konfiguracja śledzenia twarzy nie powiodła się. Spróbuj ponownie, aby kontynuować.",
        cocoLoadFailed:
          "Silnik nadzorujący jest niedostępny. Odśwież i spróbuj ponownie.",
        streamLostReacquireFailed:
          "Odzyskiwanie strumienia z kamery nie powiodło się. Ponów próbę nadzorowania.",
        calibrationInsufficientData:
          "Próbki kalibracyjne były niewystarczające. Ponów próbę kalibracji.",
        detectionCadenceUnavailable:
          "Konfiguracja czasu nie jest gotowa. Spróbuj ponownie wkrótce."
      },
      calibrationInfo: {
        heading: "Aby pomyślnie skalibrować wideo, wykonaj następujące kroki:",
        followUpHeading:
          "Jeśli problem nadal występuje, wykonaj następujące kroki:",
        initialSteps: {
          step1: {
            title: "Zadbaj o dobre oświetlenie",
            description:
              "Usiądź w dobrze oświetlonym miejscu, tak aby Twoja twarz była dobrze widoczna. Unikaj jasnego światła i okien za sobą."
          },
          step2: {
            title: "Stań twarzą w twarz bezpośrednio z kamerą",
            description:
              "Podczas kalibracji ustaw twarz na środku kadru i patrz prosto w kamerę."
          },
          step3: {
            title: "Unikaj ciemnego lub rozmytego tła",
            description: "Upewnij się, że tło jest jasne i niezbyt ciemne."
          },
          step4: {
            title: "Sprawdź uprawnienia aparatu",
            description:
              "Zezwól przeglądarce na dostęp do kamery internetowej po wyświetleniu monitu."
          },
          step5: {
            title: "Pozostań nieruchomo i spójrz na ekran",
            description:
              "Podczas kalibracji trzymaj głowę stabilnie, aby system mógł prawidłowo wykryć Twoją twarz."
          }
        },
        laterSteps: {
          step1: "Spróbuj odświeżyć stronę i ponownie skalibrować kamerę.",
          step2:
            "Zamknij inne aplikacje za pomocą kamery internetowej (np. Zoom lub Teams).",
          step3:
            "Jeśli problem będzie się powtarzał, skontaktuj się z {{contactEmail}}, przesyłając zrzut ekranu przedstawiający błąd."
        }
      }
    },
    stepper: {
      termsAndConditions: "Regulamin",
      agreeTerms: "Przeczytałem i zgadzam się z warunkami.",
      previousStep: "Poprzedni krok",
      nextStep: "Następny krok",
      startAssessment: "Rozpocznij ocenę",
      resumeAssessment: "Wznów ocenę",
      mediaCheck: "Kontrola multimediów",
      systemCheck: "Kontrola systemu",
      audioCheck: {
        intro:
          "Możesz nagrać tutaj krótkie wideo, aby sprawdzić, czy kamera i mikrofon działają prawidłowo.",
        mediaPermissionDenied:
          "Odmówiono dostępu do kamery lub mikrofonu. Włącz uprawnienia w ustawieniach przeglądarki.",
        startRecording: "Rozpocznij nagrywanie",
        stopRecording: "Zatrzymaj nagrywanie",
        unnamedMicrophone: "Nienazwany mikrofon"
      },
      stepLabel: "KROK {{step}}",
      personalDetails: "Dane osobowe",
      emailId: "Identyfikator e-mail",
      firstName: "Imię",
      lastName: "Nazwisko",
      defaultTncStatement:
        "Biorąc udział w tej ocenie, potwierdzasz, że spełniasz wymagania kwalifikacyjne określone przez firmę i wyrażasz zgodę na samodzielne ukończenie testu, bez pomocy z zewnątrz. Ocena podlega nadzorowi wideo, a kamera musi być włączona przez całą sesję w otoczeniu wolnym od zakłóceń. Wszystkie treści i materiały przekazane podczas oceny są poufne i nie wolno ich udostępniać, powielać ani rozpowszechniać. Zgadzasz się dotrzymać wyznaczonego terminu oceny; niezłożenie zgłoszenia w terminie może skutkować dyskwalifikacją. Firma nie ponosi odpowiedzialności za jakiekolwiek problemy techniczne związane z połączeniem internetowym, oprogramowaniem lub sprzętem. Dane osobowe zebrane w trakcie oceny będą przetwarzane wyłącznie w celach ewaluacyjnych i rekrutacyjnych, zgodnie z polityką prywatności firmy. Jakakolwiek próba oszukiwania, plagiatowania lub innego nieetycznego zachowania będzie prowadzić do natychmiastowej dyskwalifikacji. Przesyłając odpowiedzi, potwierdzasz, że są one ostateczne i po przesłaniu nie można wprowadzać żadnych poprawek. Firma zastrzega sobie prawo do modyfikacji lub aktualizacji niniejszego regulaminu w dowolnym momencie, a uczestnicy zostaną powiadomieni o wszelkich istotnych zmianach.",
      okay: "Dobra"
    },
    access: {
      cancelledTitle: "„{{title}}” został anulowany",
      cancelledDescription:
        "Ta ocena nie jest już aktywna i nie można uzyskać do niej dostępu. Sprawdź swój panel pod kątem innych przypisanych lub nadchodzących ocen.",
      goToHome: "Przejdź do strony głównej",
      refreshPage: "Odśwież stronę"
    },
    errorPage: {
      goBack: "Wróć",
      raiseRequest: "Zgłoś prośbę",
      retryLogin: "Zaloguj ponownie",
      contactUs: "Skontaktuj się z nami",
      goBackToEvent: "Wróć do wydarzenia",
      launchCourse: "Uruchom kurs",
      created: "Utworzono",
      starts: "Start",
      ends: "Koniec",
      untitled: "Bez tytułu"
    },
    sidebar: {
      home: "Strona główna",
      quickAccess: "Szybki dostęp",
      questionPaperAuthoring: "Tworzenie arkusza pytań",
      assessmentLibrary: "Biblioteka ocen",
      scheduleInterview: "Zaplanuj rozmowę",
      generateQuestions: "Generuj pytania",
      roleManagement: "Zarządzanie rolami",
      logout: "Wyloguj",
      noAccess: "Brak dostępu",
      noAccessWithLabel: "{{label}} (Brak dostępu)",
      noAccessToLink: "Nie masz dostępu do tego linku",
      expandSidebar: "Rozwiń pasek boczny",
      collapseSidebar: "Zwiń pasek boczny",
      expand: "Rozwiń",
      collapse: "Zwiń",
      myPreferences: "Moje preferencje"
    },
    timesUp: {
      title: "Czas oceny ukończony",
      autoSubmittedMessage:
        "Minutnik wygasł. Twoje odpowiedzi zostały zapisane, a {{featureName}} została przesłana automatycznie."
    },
    resultCard: {
      title: "Wyniki {{featureName}}",
      score: "Wynik",
      passPercentage: "Procent zaliczenia",
      marksAway:
        "Brakuje Ci {{count}} znaków do certyfikacji. Skoncentruj się na zalecanych obszarach i spróbuj ponownie.",
      certificationEarned:
        "Przekroczono wymagania certyfikacyjne i uzyskano certyfikat",
      congratulationsOnEarning:
        "Gratulujemy zdobycia certyfikatu {{featureName}}",
      almostThereTitle: "Jesteś bliżej zdobycia certyfikatu, niż myślisz",
      certificatePassedDescription:
        "Wykazałeś się wiedzą i umiejętnościami wymaganymi do uzyskania tego certyfikatu. Poświęć chwilę, aby uczcić to osiągnięcie i podzielić się nim ze swoją siecią",
      certificateFailDescription:
        "Ta próba uwidoczniła możliwości wzmocnienia twoich umiejętności. Przejrzyj polecane obszary i wróć bez obaw",
      congratsImageAlt: "Gratuluję obrazu",
      almostThereImageAlt: "Prawie na miejscu Zdjęcie"
    },
    sectionCard: {
      section: "Sekcja",
      startSection: "Rozpocznij sekcję",
      continueSection: "Kontynuuj sekcję",
      completed: "Zakończony",
      viewSection: "Zobacz sekcję",
      totalQuestions: "Całkowita liczba pytań:",
      sectionNotFound: "Nie znaleziono sekcji.",
      total: "Całkowity",
      flagged: "Taflowy"
    },
    sectionSummary: {
      totalQuestions: "Razem pytania",
      completedQuestions: "Wypełnione pytania",
      flaggedQuestions: "Oznaczone pytania",
      unattemptedQuestions: "Niewypróbowane pytania",
      codingQuestions: "Pytania dotyczące kodowania:",
      objectiveQuestions: "Obiektywne pytania:",
      goToSections: "Przejdź do sekcji",
      lowWordCountWarning:
        "Twoja odpowiedź na pytanie {{questionTitle}} składa się z mniej niż 40 słów. Jeśli wrócisz do listy sekcji, ta odpowiedź zostanie odrzucona.",
      videoNotSubmittedWarning:
        "Twój nagrany film wideo dotyczący pytania {{questionTitle}} nie został przesłany. Jeśli wrócisz do listy sekcji, ta odpowiedź zostanie odrzucona."
    },
    objective: {
      questionCounter: "Pytanie",
      marks: "Znaki:",
      explanation: "Wyjaśnienie",
      hints: "Poradnik",
      reset: "Resetuj",
      flag: "Flaga",
      unflag: "Usuń flagę",
      previous: "Poprzedni",
      saveAndNext: "Zapisz i dalej",
      saveAndViewSummary: "Zapisz i wyświetl podsumowanie sekcji",
      next: "Następny",
      viewSectionSummary: "Wyświetl podsumowanie sekcji",
      hideExplanation: "Ukryj wyjaśnienie",
      showExplanation: "Pokaż wyjaśnienie",
      hintWaitTooltip: "Musisz poczekać, aż zobaczysz kolejną wskazówkę",
      noHintsPendingTooltip: "Żadne wskazówki nie są oczekujące",
      selectOptionForExplanation:
        "Wybierz opcję, aby wyświetlić wyjaśnienie wybranej opcji"
    },
    tour: {
      shared: {
        timer:
          "Ten licznik czasu wyświetla czas pozostały do ​​oceny. Prosimy o uważne monitorowanie, aby upewnić się, że ukończono wszystkie sekcje w wyznaczonym czasie.",
        submit:
          "Po ukończeniu wszystkich części oceny możesz przesłać swoją pracę, klikając przycisk „Prześlij ocenę”. Ta czynność powoduje sfinalizowanie Twoich odpowiedzi i nie będziesz już mógł wprowadzać zmian po przesłaniu. Zanim przystąpisz do przesyłania, upewnij się, że sprawdziłeś wszystkie swoje odpowiedzi."
      },
      dashboard: {
        legend:
          "Legenda stanu sekcji pomaga zrozumieć postęp w trakcie oceny. Wykorzystuje jasne wskaźniki, aby pokazać, czy dany odcinek nie został rozpoczęty, jest w trakcie realizacji lub został ukończony. Dzięki temu szybko ocenisz, które obszary wymagają jeszcze Twojej uwagi i efektywnie zarządzasz czasem.",
        sectionCard:
          "Karta sekcji zawiera szczegółowy przegląd każdej sekcji oceny. Wyświetla tytuł sekcji, jej aktualny status i najważniejsze informacje na temat pytań w sekcji. Obejmuje to całkowitą liczbę pytań, liczbę oflagowanych pytań i liczbę pytań, które zostały ukończone. Karta sekcji pomaga monitorować postępy i identyfikować obszary, które mogą wymagać większej uwagi."
      },
      coding: {
        titles:
          "U góry strony znajduje się przejrzysty wyświetlacz tytułu oceny i tytułu sekcji. Dzięki temu możesz śledzić swoje bieżące zadanie i mieć pewność, że znasz konkretną sekcję, nad którą pracujesz. Odwołuj się do tych tytułów, aby zachować orientację podczas poruszania się po pytaniach.",
        sectionsButton:
          "Ten przycisk umożliwia łatwy powrót do panelu sekcji. Użyj go, aby powrócić do głównego przeglądu swojej oceny, gdzie możesz przeglądać i zarządzać postępem wszystkich sekcji. Zapewnia szybki sposób ponownej oceny ogólnego postępu bez utraty bieżącej pracy.",
        sidebar:
          "Pasek boczny zawiera przegląd wszystkich pytań w ramach bieżącej sekcji, którą próbujesz rozwiązać. Umożliwia szybkie poruszanie się pomiędzy pytaniami poprzez proste wybranie odpowiedniego bloku. Każdy blok pytań jest oznaczony kolorem w zależności od jego statusu, co ułatwia śledzenie postępów i w razie potrzeby przechodzenie do konkretnych pytań.",
        questionCard:
          "Ta karta zawiera pytanie, nad którym aktualnie pracujesz, wyświetlając pełny monit oraz wszelkie odpowiednie instrukcje lub wymagania wejściowe. Został zaprojektowany tak, aby zapewnić jasny obraz wykonywanego zadania, wraz ze wszystkimi informacjami niezbędnymi do kontynuowania. Znajdziesz tu także przycisk umożliwiający oznaczenie pytania do późniejszego sprawdzenia, dzięki czemu w razie potrzeby będziesz mógł łatwo do niego wrócić. Dodatkowo znajdują się przyciski nawigacyjne, które pozwalają przejść do następnego lub poprzedniego pytania bez konieczności powrotu do paska bocznego, zapewniając płynne i sprawne przejście przez ocenę.",
        editor:
          "Edytor kodu to miejsce, w którym będziesz pisać i modyfikować swoje rozwiązania. Możesz przełączać się między różnymi językami programowania, aby spełnić wymagania każdego pytania. Dodatkowo masz możliwość dostosowania motywu edytora, aby zapewnić wygodniejszy kodowanie. Jeśli wolisz więcej miejsca na ekranie, edytor można rozszerzyć do pełnej szerokości, co zapewni większy obszar do pracy. Funkcje te zaprojektowano tak, aby zapewnić elastyczne i przyjazne dla użytkownika środowisko podczas wykonywania zadań związanych z kodowaniem."
      }
    },
    toast: {
      proctoringViolationDetected: "Wykryto naruszenie zasad nadzoru",
      messages: {
        forbiddenObjectDetected: "Wykryto zabroniony obiekt",
        noFaceDetected: "Nie wykryto twarzy",
        multipleFacesDetected: "Wykryto wiele twarzy",
        lookingAwayFromScreen: "Odwracając wzrok od ekranu",
        notLookingAtScreen: "Nie patrząc na ekran",
        faceNotOrientedCorrectly: "Twarz nie jest prawidłowo zorientowana",
        eyesNotFullyOpen: "Oczy nie do końca otwarte",
        copyNotAllowed: "Kopiowanie jest niedozwolone",
        cutRestricted: "Cięcie jest ograniczone w trybie nadzoru",
        pasteNotAllowed: "Wklejanie jest niedozwolone",
        contextMenuNotAllowed: "Otwieranie menu kontekstowego jest niedozwolone"
      }
    },
    whatsNext: {
      heading: "Co dalej?",
      attemptsRemaining: "pozostałe próby",
      passed: {
        shareLinkedInTitle: "Udostępnij na LinkedIn",
        shareLinkedInSubtitle:
          "Świętuj swoje osiągnięcie w swojej sieci zawodowej.",
        viewCertificateTitle: "Zobacz certyfikat",
        viewCertificateSubtitle:
          "Pobierz lub uzyskaj dostęp do swojego certyfikatu w dowolnym momencie.",
        shareGloTitle: "Udostępnij doświadczenie",
        shareGloSubtitle:
          "Inspiruj współpracowników, publikując swoje osiągnięcia wewnętrznie."
      },
      failed: {
        reviewLearningResourcesTitle: "Przejrzyj zasoby edukacyjne",
        reviewLearningResourcesSubtitle:
          "Wzmocnij umiejętność wymagającą uwagi.",
        retakeAssessmentTitle: "Powtórz ocenę",
        retakeAssessmentSubtitle: "Wykaż swoje postępy i aktualne zrozumienie."
      },
      modal: {
        title: "Podziel się osiągnięciem",
        linkedInPostLabel: "Udostępnij na LinkedIn jako post",
        linkedInProfileLabel: "Dodaj jako certyfikat do profilu LinkedIn",
        gloLabel: "Udostępnij na Glo",
        comingSoon: "Już wkrótce",
        infoMessage: "Aby udostępnić, musisz być zalogowany na platformie."
      }
    },
    time: {
      hour_one: "{{count}} godzina",
      hour_other: "{{count}} godzin",
      minute_one: "{{count}} minuta",
      minute_other: "{{count}} minut",
      hourShort: "godz",
      minuteShort: "min",
      secondShort: "s"
    },
    accessScreens: {
      attemptResultProcessing: {
        alt: "Wyniki {{featureName}} są przetwarzane",
        title: "Twoje wyniki są przetwarzane",
        description:
          "Nadal sprawdzamy Twoją {{featureName}}. Sprawdź ponownie wkrótce!"
      },
      coolOffPeriod: {
        alt: "Okres ochłodzenia",
        title: "Kolejna próba dostępna wkrótce",
        completedAttempt: "Podjęłeś już taką próbę",
        nextAttemptIntro: ". Twoja następna próba będzie dostępna w"
      },
      maxAttemptExceeded: {
        alt: "Osiągnięto maksymalną liczbę prób",
        title: "Osiągnięto maksymalną liczbę prób",
        description:
          "Wykorzystałeś wszystkie dostępne próby tej {{featureName}}. Nie można podejmować dalszych prób."
      },
      scheduleNotStarted: {
        alt: "Harmonogram nie został rozpoczęty",
        title: "{{featureName}} Jeszcze nie rozpoczęte",
        scheduledPrefix: "The",
        scheduledOn: "ma się rozpocząć dnia",
        checkBack:
          "Sprawdź ponownie w {{time}} lub odśwież, gdy czas się zacznie."
      },
      scheduleTimeCompleted: {
        alt: "Czas harmonogramu ukończony",
        title: "Okno {{featureName}} zamknięte",
        description:
          "Zaplanowany czas dla tej {{featureName}} minął. Nie możesz już rozpocząć ani przesłać próby."
      }
    },
    attemptDetails: {
      allAttempts: "Wszystkie próby",
      headers: {
        attempt: "Próba",
        attemptedOn: "Próbowano dalej",
        percentage: "Procent"
      },
      viewAllAttempts: "Wyświetl wszystkie próby"
    },
    survey: {
      questions: {
        q1: "W skali od 1 do 5, jak jasne były dla Ciebie pytania {{featureName}}?",
        q2: "Poczułem się odpowiednio przygotowany do tematów poruszanych w {{featureName}}",
        q3: "Platforma wykorzystana w {{featureName}} była przyjazna dla użytkownika i funkcjonalna",
        q4: "Uważam, że moje odpowiedzi skutecznie pokazały moje umiejętności i wiedzę"
      },
      stronglyDisagree: "Zdecydowanie się nie zgadzam",
      stronglyAgree: "Zdecydowanie się zgadzam",
      submitFeedback: "Prześlij opinię"
    },
    cameraPreview: {
      loadingAlt: "Ładowanie podglądu kamery",
      delayedMessage:
        "Kalibracja trwa dłużej niż oczekiwano ze względu na powolną sieć. Poczekaj lub spróbuj odświeżyć stronę."
    },
    proctoring: {
      engineLoadFailedStatus: "Nie udało się załadować silnika Proctoring",
      runtimeErrors: {
        cameraPermissionDenied:
          "Dostęp do kamery jest blokowany przez ustawienia uprawnień przeglądarki.",
        cameraUnavailable:
          "Kamera jest niedostępna lub jest obecnie używana przez inną aplikację.",
        unableToLoadModel:
          "Nie można wczytać modelu nadzorującego wykrywanie obiektów.",
        webglRecoveryFailed:
          "Odzyskiwanie WebGL nie powiodło się podczas przywracania wykrywania obiektów."
      },
      logs: {
        engineLoadFailed: "Nie udało się załadować ProctoringEngine:",
        videoPlayRejected: "Odtwarzanie wideo() zostało odrzucone:",
        cameraTrackEnded:
          "Zakończono śledzenie kamery – próba ponownego przejęcia",
        cameraReacquired: "Kamera ponownie pobrana przy próbie {{attempt}}",
        cameraReacquireAttemptFailed:
          "Próba ponownego przejęcia kamery {{attempt}} nie powiodła się:",
        cameraReacquireFailedAll:
          "Ponowne zarejestrowanie kamery nie powiodło się po wszystkich próbach — zgłaszanie kamery odłączonej w każdym cyklu",
        uploadFailedQueued:
          "Przesyłanie nadzorujące nie powiodło się po {{attempts}} próbach, oczekiwanie na ponowną próbę:",
        uploadAttemptFailedRetrying:
          "Próba przesyłania {{attempt}} do nadzoru nie powiodła się, próba ponawiana...",
        drainedQueuedViolation:
          "Usunięto naruszenie w kolejce: {{violationType}} (pozostało {{remaining}})",
        queueDrainFailed:
          "Opróżnianie kolejki nie powiodło się, spróbuję ponownie w następnym cyklu:",
        cocoLoadFailed: "Ładowanie COCO-SSD nie powiodło się:",
        faceProcessingError: "Błąd przetwarzania twarzy:",
        errorProcessingFrame: "Błąd przetwarzania ramki:",
        faceMeshInitError: "Błąd inicjalizacji siatki twarzy:"
      }
    }
  }
} as const;

export default pl;
